export default "__VITE_ASSET__D8425g04__"